import React from 'react';
import { CONSTANTS } from '../../utils';
import { SurveyDataTypes } from '../../modules/admin-panel/pages/clients/models';
import { IIconProps } from '../icons/IIconProps';
import { CalendarIcon, OngoingIcon, PastIcon } from '../icons';
import './surveyDataCard.styles.scss';

interface SurveyCardProps {
	title: string;
	value?: number;
	type: SurveyDataTypes;
}

const mapSurveyIcon: Record<string, React.ElementType<IIconProps>> = {
	[SurveyDataTypes.pastSurveysCount]: PastIcon,
	[SurveyDataTypes.activeSurveysCount]: OngoingIcon,
	[SurveyDataTypes.scheduledSurveysCount]: CalendarIcon,
};

export const SurveyDataCard = ({ title, value, type }: SurveyCardProps) => {
	const Icon = mapSurveyIcon[type];

	return (
		<div className="survey-data-card">
			<Icon iconClass="survey-data-card__icon" />
			<div className="survey-data-card__text">
				<p className="survey-data-card__value">
					{typeof value === 'number' ? value : CONSTANTS.noData}
				</p>
				<p className="survey-data-card__title">{title}</p>
			</div>
		</div>
	);
};
